var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4",staticStyle:{"position":"relative"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('span',{staticClass:"main-title"},[_vm._v("FOOD SUMMARY |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Sale store report")])]),_c('v-flex',{staticStyle:{"display":"flex","justify-content":"flex-end"},attrs:{"xs12":"","sm6":""}},[_c('download-excel',{attrs:{"data":_vm.export_form_sale_store,"fields":{
            No: 'no',
            'Order code': 'order_code',
            'Order ref.': 'order_base_code',
            'Customer name': 'order_customer_full_name',
            'Rider name': 'order_rider_full_name',
            'Store name': 'store_name',
            'Item price': 'item_price',
            Transport: 'transport',
            'Extra store': 'extra_store',
            Promotion: 'promotion',
            'Com Omise 4%': 'order_com',
            Revenue: 'summary',
            Remark: 'remark',
          },"name":'SaleStoreReport-' +
              (_vm.search_config.search_store_id == 0
                ? 'All_store'
                : _vm.sale_store_list.length > 0
                ? _vm.sale_store_list[0].store_name
                : '') +
              '_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.xls'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls ")],1)],1),_c('download-excel',{attrs:{"data":_vm.export_form_sale_store,"type":"csv","fields":{
            No: 'no',
            'Order code': 'order_code',
            'Order ref.': 'order_base_code',
            'Customer name': 'order_customer_full_name',
            'Rider name': 'order_rider_full_name',
            'Store name': 'store_name',
            'Item price': 'item_price',
            Transport: 'transport',
            'Extra store': 'extra_store',
            Promotion: 'promotion',
            'Com Omise 4%': 'order_com',
            Revenue: 'summary',
            Remark: 'remark',
          },"name":'SaleStoreReport-' +
              (_vm.search_config.search_store_id == 0
                ? 'All_store'
                : _vm.sale_store_list.length > 0
                ? _vm.sale_store_list[0].store_name
                : '') +
              '_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.csv'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv ")],1)],1)],1)],1)],1),_c('searchFood'),_c('storeReportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }